import React, { useEffect, useRef, useState } from "react";
import {
  LogoContainer,
  AdminInfoContainer,
  AdminName,
  AdminAccount,
  NavContainer,
  ProfilePicEmpty,
  IconContainer,
  NavDiv,
  StyledBar,
  ButtonsContainer,
  UpgradeButton,
  LogoutButton,
  StyledNavLink,
  LogoGiftIcon,
  ArrowIcon,
  LogoutIcon,
  ProfilePhoto,
  ChevronContainer,
  ChevronRight,
  ChevronLeft,
  Animation,
  SidebarContainer,
  TestText,
  FilterLabel,
  Filter,
  FilterSearch,
  FilterWrapper,
  FiltersContainer,
  FilterTitle,
  FilterTitleContainer,
  FilterSearchContainer,
  SearchIcon,
  FilterRow,
} from "./Sidebar.style";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as FilterIcon } from "../../../assets/icons/filters.svg";
import { ReactComponent as Logo2 } from "../../../assets/icons/logo_purple.svg";
import { ReactComponent as Dashboard } from "../../../assets/icons/dashboard.svg";
import { ReactComponent as Marketplace } from "../../../assets/icons/market.svg";
import { ReactComponent as Recipients } from "../../../assets/icons/usergroup.svg";
import { ReactComponent as Coupon } from "../../../assets/icons/coupon.svg";
import { ReactComponent as AccountSettings } from "../../../assets/icons/settings.svg";
import { ReactComponent as Wallet } from "../../../assets/icons/wallet.svg";
import { ReactComponent as OrderHistory } from "../../../assets/icons/clock.svg";
import { ReactComponent as Favorite } from "../../../assets/icons/heart.svg";
import { ReactComponent as Subscription } from "../../../assets/icons/sub.svg";
import { ReactComponent as DashboardUnSelected } from "../../../assets/icons/dashboardUnSelected.svg";
import { ReactComponent as MarketplaceUnSelected } from "../../../assets/icons/marketUnSelected.svg";
import { ReactComponent as RecipientsUnSelected } from "../../../assets/icons/usergroupUnSelected.svg";
import { ReactComponent as CouponUnSelected } from "../../../assets/icons/couponUnSelected.svg";
import { ReactComponent as AccountSettingsUnSelected } from "../../../assets/icons/settingsUnSelected.svg";
import { ReactComponent as WalletUnSelected } from "../../../assets/icons/walletUnSelected.svg";
import { ReactComponent as OrderHistoryUnSelected } from "../../../assets/icons/clockUnSelected.svg";
import { ReactComponent as FavoriteUnSelected } from "../../../assets/icons/heartUnSelected.svg";
import { ReactComponent as SubscriptionUnSelected } from "../../../assets/icons/subUnSelected.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  selectBusinessUserInfo,
  selectCompanyInfo,
} from "../../../store/slices/businessUser/slice";
import { useTranslation } from "react-i18next";
import { selectUserInfo } from "../../../store/slices/authRecipient/slice";
import { logoutRecipient } from "../../../store/slices/authRecipient/asyncThunks";
import { logout } from "../../../store/slices/businessUser/asyncThunks";
import { countClickAction } from "../../../store/slices/common/asyncThunks";
import { FRONT_URL } from "../../../api";
import openToast from "../../../utils/toast";
import {
  selectedLocale,
  selectSidebarOpen,
  setSidebarOpen,
} from "../../../store/slices/common/slice";
import Icon from "../../../components/Icon";
import Checkbox from "../../../components/Checkbox/Checkbox.js";
import { checkPermission, priceFormatter } from "../../../utils/utils";
import { businessUserRoleAction } from "../../../utils/constants.js";

const Sidebar = ({ marketplace, headerVisible, setQueryData }) => {
  const userInfo = useSelector(selectUserInfo);
  const { name, companyLogo } = useSelector(selectCompanyInfo);
  const businessUser = useSelector(selectBusinessUserInfo);
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const toastId = useRef(null);
  const opened = useSelector(selectSidebarOpen);
  const [searchPrice, setSearchPrice] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category");
  const priceFromParam = queryParams.get("priceFrom");
  const priceToParam = queryParams.get("priceTo");

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const priceFilters = [
    { id: 1, priceFrom: 0, priceTo: 100 },
    { id: 2, priceFrom: 101, priceTo: 300 },
    { id: 3, priceFrom: 301, priceTo: 500 },
    { id: 4, priceFrom: 500 },
  ];

  const navLinks = [
    {
      to: "/admin-portal/dashboard",
      icon: <Dashboard />,
      iconUnSelected: <DashboardUnSelected />,
      label: "dashboard",
    },
    // {
    //   to: "/admin-portal/marketplace",
    //   icon: <Marketplace />,
    //   iconUnSelected: <MarketplaceUnSelected />,
    //   label: "marketplace",
    // },
    {
      to: "/admin-portal/recipients?page=1",
      icon: <Recipients />,
      iconUnSelected: <RecipientsUnSelected />,
      label: "recipients2",
    },
    {
      to: "/admin-portal/order-history?marketplacePage=1&giftsPage=1",
      // icon: <OrderHistory />,
      // iconUnSelected: <OrderHistoryUnSelected />,
      icon: <Marketplace />,
      iconUnSelected: <MarketplaceUnSelected />,
      label: "my-orders",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_bank_transfers
      )
        ? "/admin-portal/billing?billingsPage=1&bankTransfersPage=1"
        : "/admin-portal/billing?billingsPage=1",
      icon: <Wallet />,
      iconUnSelected: <WalletUnSelected />,
      label: "wallet",
    },
    {
      to: "/admin-portal/favorite",
      icon: <Favorite />,
      iconUnSelected: <FavoriteUnSelected />,
      label: "favorites",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_subscriptions
      )
        ? "/admin-portal/subscriptions"
        : "/admin-portal/business-subscriptions?page=1",
      icon: <Subscription />,
      iconUnSelected: <SubscriptionUnSelected />,
      label: "subscriptions",
    },

    ...(checkPermission(businessUser, businessUserRoleAction.get_users)
      ? [
          {
            to: "/admin-portal/customers?page=1",
            icon: <Recipients />,
            iconUnSelected: <RecipientsUnSelected />,
            label: "customers",
          },
        ]
      : []),

    ...(checkPermission(businessUser, businessUserRoleAction.get_coupons)
      ? [
          {
            to: "/admin-portal/coupons",
            icon: <Coupon />,
            iconUnSelected: <CouponUnSelected />,
            label: "coupons",
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (!priceFromParam && !priceToParam) {
      setSearchPrice("");
    }

    if (!priceFromParam && priceFromParam !== 0 && priceToParam) {
      setSearchPrice(priceToParam);
    }

    if (setQueryData) {
      setQueryData((prev) => {
        const { priceFrom, priceTo, ...rest } = prev;

        return {
          ...rest,
          ...(priceFromParam && { priceFrom: priceFromParam }),
          ...(priceToParam && { priceTo: priceToParam }),
        };
      });
    }
  }, [priceFromParam, priceToParam]);

  const handleLogout = () => {
    window.scrollTo(0, 0);

    if (businessUser.id > 0) {
      dispatch(logout())
        .unwrap()
        .then(() => {
          navigation("/");
        })
        .catch((error) => {
          openToast(toastId, "new-password", "error", t(error.message));
        });
    } else if (userInfo.id > 0) {
      dispatch(logoutRecipient())
        .unwrap()
        .then(() => {
          navigation("/");
        })
        .catch((error) => {
          openToast(toastId, "new-password", "error", t(error.message));
        });
    }
  };

  const UserInfo = () => {
    return (
      <AdminInfoContainer $superAdmin={businessUser.role === "superAdmin"}>
        {companyLogo ? (
          <ProfilePhoto src={companyLogo} alt="profilepicture" />
        ) : (
          <ProfilePicEmpty>
            <div>
              <LogoGiftIcon />
            </div>
          </ProfilePicEmpty>
        )}
        <AdminName>
          {!userInfo.fullName
            ? name
              ? `${name.length > 30 ? name?.slice(0, 30) + "..." : t(name)}`
              : `${t(businessUser.fullName)}`
            : name
            ? `${name}`
            : `${userInfo.fullName}`}
        </AdminName>
        {businessUser.id > 0 && (
          <AdminAccount>{t("admin-account")}</AdminAccount>
        )}
        {userInfo?.id > 0 && <AdminAccount>{t("user-account")}</AdminAccount>}
      </AdminInfoContainer>
    );
  };

  const Logo = () => {
    return FRONT_URL !== "https://portal.ygii.app" ? (
      <LogoContainer>
        <TestText $ar={ar}>TEST</TestText>
        <Logo2 height={50} width={50} />
      </LogoContainer>
    ) : (
      <LogoContainer>
        <Logo2 height={50} width={50} />
      </LogoContainer>
    );
  };

  const Buttons = () => {
    return (
      <ButtonsContainer $superAdmin={businessUser.role === "superAdmin"}>
        {businessUser.role === "superAdmin" && (
          <UpgradeButton
            style={{ marginBottom: -10 }}
            onClick={() => {
              window.scrollTo(0, 0);
              navigation("/ops-portal");
            }}
          >
            {t("ops-portal")}
            <ArrowIcon $ar={ar} />
          </UpgradeButton>
        )}

        <UpgradeButton
          onClick={() => {
            window.scrollTo(0, 0);
            navigation("/sign-up/steps/upgrade");
          }}
        >
          {t("upgrade-your-account")}
          <ArrowIcon $ar={ar} />
        </UpgradeButton>
        {/* <LogoutButton onClick={handleLogout}>
          <Icon icon={<LogoutIcon />} selectedLocale={ar} />
          {t("logout")}
        </LogoutButton> */}
      </ButtonsContainer>
    );
  };

  const [isVisible, setIsVisible] = useState(opened);

  useEffect(() => {
    let timer;
    if (opened) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 150);
    }

    return () => clearTimeout(timer);
  }, [opened]);

  const handleChecked = (filter) => {
    let checked = false;
    if (
      filter.priceFrom === parseInt(priceFromParam) &&
      filter.priceTo === parseInt(priceToParam)
    ) {
      checked = true;
    } else if (
      (!filter.priceFrom && filter.priceTo === parseInt(priceToParam)) ||
      (filter.priceFrom === parseInt(priceFromParam) && !filter.priceTo)
    ) {
      checked = true;
    }
    return checked;
  };

  return (
    <SidebarContainer
      $opened={opened}
      $ar={ar}
      $height={
        !headerVisible &&
        (location.pathname === "/admin-portal/marketplace" ||
          location.pathname === "/ops-portal/marketplace" ||
          location.pathname === "/marketplace")
      }
    >
      {!opened ? (
        <ChevronContainer
          $ar={ar}
          onClick={() => {
            dispatch(setSidebarOpen(!opened));
          }}
        >
          <ChevronRight />
        </ChevronContainer>
      ) : (
        <ChevronContainer
          $ar={ar}
          onClick={() => {
            dispatch(setSidebarOpen(!opened));
          }}
          $left
        >
          <ChevronLeft />
        </ChevronContainer>
      )}
      {isVisible &&
        (marketplace ? (
          <StyledBar style={{ justifyContent: "flex-start" }}>
            <Animation $open={opened} style={{ width: "100%" }}>
              <FiltersContainer>
                <FilterWrapper>
                  <FilterTitleContainer>
                    {/* <FilterIcon /> */}
                    <FilterTitle>{t("filters")}</FilterTitle>
                  </FilterTitleContainer>
                  <FilterSearchContainer>
                    <FilterSearch
                      placeholder={t("price")}
                      value={searchPrice}
                      onChange={(e) => {
                        setSearchPrice(e.target.value);
                        if (e.target.value) {
                          let path = location.pathname;
                          let query = "?";
                          if (category && category !== null) {
                            path += `?category=${category}`;
                            query = "&";
                          }

                          path += query + `priceTo=${e.target.value}`;

                          navigation(path);
                        } else {
                          let path = location.pathname;
                          if (category && category !== null) {
                            path += `?category=${category}`;
                          }

                          navigation(path);
                        }
                      }}
                    />
                    <SearchIcon $active={searchPrice !== ""} />
                  </FilterSearchContainer>
                  {priceFilters.map((filter, i) => {
                    return (
                      <Filter
                        key={i}
                        onClick={() => {
                          if (
                            (filter.priceFrom === parseInt(priceFromParam) &&
                              filter.priceTo === parseInt(priceToParam)) ||
                            filter.priceFrom === parseInt(priceFromParam)
                          ) {
                            let path = location.pathname;
                            if (category && category !== null) {
                              path += `?category=${category}`;
                            }
                            navigation(path);
                          } else {
                            setSearchPrice("");

                            let path = location.pathname;
                            let query = "?";
                            if (category && category !== null) {
                              path += `?category=${category}`;
                              query = "&";
                            }

                            if (filter.priceFrom || filter.priceFrom === 0) {
                              path += query + `priceFrom=${filter.priceFrom}`;
                              query = "&";
                            }
                            if (filter.priceTo) {
                              path += query + `priceTo=${filter.priceTo}`;
                            }
                            navigation(path);
                          }
                        }}
                      >
                        <Checkbox checked={handleChecked(filter)} size={24} />
                        {filter.priceTo ? (
                          filter.priceFrom === 0 ? (
                            <FilterLabel>
                              {`Under ${priceFormatter(
                                filter.priceTo,
                                false,
                                0
                              )} SR`}
                            </FilterLabel>
                          ) : (
                            <FilterRow>
                              <FilterLabel>
                                {priceFormatter(filter.priceFrom, false, 0)}
                              </FilterLabel>
                              <FilterLabel>SR</FilterLabel>
                              <FilterLabel>-</FilterLabel>
                              <FilterLabel>
                                {priceFormatter(filter.priceTo, false, 0)}
                              </FilterLabel>
                              <FilterLabel>SR</FilterLabel>
                            </FilterRow>
                          )
                        ) : (
                          <FilterLabel>
                            {`Above ${priceFormatter(
                              filter.priceFrom,
                              false,
                              0
                            )} SR`}
                          </FilterLabel>
                        )}
                      </Filter>
                    );
                  })}
                </FilterWrapper>
              </FiltersContainer>
            </Animation>
          </StyledBar>
        ) : (
          <StyledBar>
            <Animation $open={opened}>
              {/* <UserInfo /> */}
              {businessUser.id > 0 && (
                <>
                  {navLinks.map(({ to, icon, iconUnSelected, label }) => (
                    <StyledNavLink
                      key={to}
                      to={to}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        if (label === "marketplace") {
                          dispatch(countClickAction("marketplace"));
                        }
                      }}
                      children={({ isActive }) => {
                        return (
                          <>
                            <IconContainer>
                              {isActive ? (
                                <Icon icon={icon} selectedLocale={ar} />
                              ) : (
                                <Icon
                                  icon={iconUnSelected}
                                  selectedLocale={ar}
                                />
                              )}
                            </IconContainer>
                            {t(`${label}`)}
                          </>
                        );
                      }}
                    />
                  ))}
                  {/* {role === "superAdmin" &&
                    superAdminNavLinks.map(
                      ({ to, icon, iconUnSelected, label }) => (
                        <StyledNavLink
                          onClick={() => {
                            window.scrollTo(0, 0);
                          }}
                          key={to}
                          to={to}
                          children={({ isActive }) => {
                            return (
                              <>
                                <IconContainer>
                                  {isActive ? (
                                    <Icon icon={icon} selectedLocale={ar} />
                                  ) : (
                                    <Icon
                                      icon={iconUnSelected}
                                      selectedLocale={ar}
                                    />
                                  )}
                                </IconContainer>
                                {t(`${label}`)}
                              </>
                            );
                          }}
                        />
                      )
                    )} */}
                  <StyledNavLink
                    onClick={() => {
                      window.scrollTo(0, 0);
                    }}
                    to={"/admin-portal/account-settings"}
                    children={({ isActive }) => {
                      return (
                        <>
                          <IconContainer>
                            {isActive ? (
                              <Icon
                                icon={<AccountSettings />}
                                selectedLocale={ar}
                              />
                            ) : (
                              <Icon
                                icon={<AccountSettingsUnSelected />}
                                selectedLocale={ar}
                              />
                            )}
                          </IconContainer>
                          {t("account-settings")}
                        </>
                      );
                    }}
                  />
                  <StyledNavLink
                    onClick={handleLogout}
                    to={"/"}
                    $logout
                    style={{ marginLeft: 3 }}
                    children={() => {
                      return (
                        <>
                          <Icon icon={<LogoutIcon />} selectedLocale={ar} />
                          {t("logout")}
                        </>
                      );
                    }}
                  />

                  <Buttons />
                </>
              )}

              {!!userInfo?.id && (
                <NavContainer>
                  <NavDiv>
                    <StyledNavLink
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                      to="/user-portal/recipient/pick-a-gift"
                      children={({ isActive }) => {
                        return (
                          <>
                            <IconContainer>
                              {isActive ? (
                                <Icon
                                  icon={<Dashboard />}
                                  selectedLocale={ar}
                                />
                              ) : (
                                <Icon
                                  icon={<DashboardUnSelected />}
                                  selectedLocale={ar}
                                />
                              )}
                            </IconContainer>
                            {t("received-gifts")}
                          </>
                        );
                      }}
                    />
                  </NavDiv>

                  <LogoutButton
                    style={{ marginLeft: 15 }}
                    onClick={handleLogout}
                  >
                    <Icon icon={<LogoutIcon />} selectedLocale={ar} />
                    {t("logout")}
                  </LogoutButton>
                </NavContainer>
              )}
            </Animation>
          </StyledBar>
        ))}
      {isVisible && (
        <Animation
          $open={opened}
          style={{ position: "absolute", bottom: 20, left: 20 }}
        >
          <Logo />
        </Animation>
      )}
    </SidebarContainer>
  );
};

export default Sidebar;
